import React from "react"
import Samples from "./Samples"
import BatchEditReactButton from "./BatchEditReactButton"
import SFSnackbar from "./SFSnackbar"
import sampleStore from "../stores/sampleStore"
import userStore from "../stores/userStore"
import snackbarStore from "../stores/snackbarStore"
import collectionStore from "../stores/collectionStore"
import Sample from "../models/sample"
import User from "../models/user"

import { observer, Provider } from "mobx-react"

const stores = {
  sampleStore,
  userStore,
  snackbarStore,
  collectionStore
}

@observer
export default class SamplesStoreWrapper extends React.Component {
  static defaultProps = {
    pageType: null,
    showBatchEditButton: false
  }

  constructor(props) {
    super(props)
    if (props.showBatchEditButton) {
      sampleStore.showSampleSelect = true
      sampleStore.showBatchEditButton = true
    }
  }

  componentDidMount() {
    // Load selectedSamples on the client side after hydration
    const { currentUser, samples, showBatchEditButton } = this.props

    if (currentUser) {
      userStore.currentUser = new User(currentUser)
    }

    samples.forEach((sampleJSON) => {
      sampleStore.addSample(new Sample(sampleJSON))
    })

    sampleStore.loadFromLocalStorage();
  }

  render() {
    const { pageType, pagyMetadata, showBatchEditButton } = this.props

    return (
      <Provider {...stores}>
        <Samples pagyMetadata={pagyMetadata}  />
        {showBatchEditButton && <BatchEditReactButton pageType={pageType} />}
        <SFSnackbar />
      </Provider>
    )
  }
}
